import React from 'react';
import { Box, Card, CardContent, Typography, Chip, Stack, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';

const CPOShipmentCard = ({ data, onDelete }) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Chip 
              label={`Envío No: ${data.shipmentNo}`}
              size="medium"
              color="primary"
              variant="filled"
            />
            {onDelete && (
              <IconButton
                size="small"
                color="error"
                onClick={() => onDelete(data)}
                aria-label="Eliminar envío"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Cantidad enviada:
            </Typography>
            <Typography variant="body1">
              {data.shippedQuantity}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Fecha de envío:
            </Typography>
            <Typography variant="body1">
              {dayjs(data.shippedDate).format('DD/MM/YYYY')}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CPOShipmentCard;
